import React from "react";
import { List } from "antd";

import {
    IActivityCategoryDefinition,
    IActivityDefinition,
    IActivityDefinitions,
    IUserActivityMinimal,
} from "@Models/IActivityDetails";
import ActivityIcon from "@Components/activity/ActivityIcon";
import appQueryClient from "@AppQueryClient";
import { QueryKeys } from "@Constants";

import "@Styles/components/activityBreakdown.scss";

interface IProps {
  userMinimal: IUserActivityMinimal[];
  isFetching: boolean;
}

interface IActivityBreakdownItem {
  id: string;
  amount: number;
  label: string;
  categoryName: string;
}

const ActivityBreakdown: React.FC<IProps> = ({ userMinimal, isFetching }: IProps) => {
  const definitions = appQueryClient.getQueryData<IActivityDefinitions>([QueryKeys.ActivityDefinitions]);
  
  const countActivitiesBreakdown = (
    definitions: IActivityDefinitions,
    userMinimal: IUserActivityMinimal[]
  ): IActivityBreakdownItem[] => {
    const totalActivitiesAmount = {};
    userMinimal?.forEach((x) => {
      const activityId = x.activityId;
      totalActivitiesAmount[activityId] = (totalActivitiesAmount[activityId] || 0) + 1;
    });

    const res: IActivityBreakdownItem[] = [];
    Object.entries(totalActivitiesAmount).forEach(([id, amount]) => {
      const activity: IActivityDefinition = definitions?.activities.find((item) => item.activityId === id);
      const category: IActivityCategoryDefinition = definitions?.categories.find(
        (item) => item.activityCategoryId === activity.activityCategoryId
      );
      res.push({
        id,
        amount: amount as number,
        label: activity?.label,
        categoryName: category?.categoryName,
      });
    });
    return res;
  };

  const activityBreakdown = countActivitiesBreakdown(definitions, userMinimal);
  return (
    <section className="activity-breakdown">
      <List
        className="activity-breakdown-list"
        dataSource={activityBreakdown}
        renderItem={(item: IActivityBreakdownItem) => (
          <List.Item key={item.id} className="activity-breakdown-item">
            <div className="activity-breakdown-label">
              <ActivityIcon categoryName={item.categoryName} style={{ marginRight: "10px" }} size={24} />
              <span>{item.label}</span>
            </div>
            <span>{item.amount}</span>
          </List.Item>
        )}
      />
    </section>
  );
};

ActivityBreakdown.defaultProps = {
  userMinimal: []
};

export default ActivityBreakdown;
